/* eslint-disable */
export default function registerReview($, apower) {
  const { tr } = apower;
  //bottom review for article page
  $.register("mobile-review", {
    template:
      '<div class="mobile-review">' +
      '<div class="mobile-review-wrapper">' +
      '<div class="mobile-comment-btn">{@@comments}</div>' +
      '<div class="mobile-review-btns">' +
      '<div class="mobile-rating-btn"></div>' +
      '<div class="mobile-share-btn" data-open-share></div>' +
      '<div class="mobile-comment-count"></div>' +
      "</div>" +
      "</div>" +
      "</div>",

    target: "body",

    ref: {
      countEl: ".mobile-comment-count",
      commentBtn: ".mobile-comment-btn",
    },

    init: function () {
      var commentWin = $(".comment-win");

      this.countEl.text($(".comment-count").eq(0).text());

      this.commentBtn.$on("click", function (e) {
        $.newCom("mobile-comment-form").show();
      });

      this.countEl.$on(
        "click",
        function (e) {
          $.com("open-comment").prototype.showCommentWin();
          $(".comment-win-mask").css("bottom", this.el[0].offsetHeight);
        },
        this
      );

      apower.scroller.on(
        "down",
        function () {
          if (!commentWin.length || !commentWin.is(":visible")) {
            this.el.hide();
          }
        },
        this
      );

      apower.scroller.on(
        "up",
        function () {
          this.el.show();
        },
        this
      );
    },
  });

  //review form
  $.register("review-form", "win", {
    template:
      '<form class="win review-form">' +
      '<h2 class="win-head">{@@write_your_review}</h2>' +
      '<div class="win-body">' +
      '<div class="rating selectable" data-selectable data-auto-set>' +
      '<div class="rating-stars"></div>' +
      '<div class="rating-text"></div>' +
      "</div>" +
      '<div class="title">' +
      '<input type="text" placeholder="{@@title}" name="title" maxlength="100">' +
      "</div>" +
      '<div class="text">' +
      '<textarea placeholder="{@@write_your_review}" name="review" maxlength="1024" required="required"></textarea>' +
      '<div class="invalid-text">{@@invalid_review}</div>' +
      "</div>" +
      '<div class="name">' +
      '<input type="text" placeholder="{@@name}" name="name" maxlength="100" required="required">' +
      '<div class="invalid-text">{@@invalid_name}</div>' +
      "</div>" +
      '<div class="email">' +
      '<input type="email" placeholder="{@@email}" name="email" maxlength="100" required="required" pattern="^[\\w-]+(?:\\.[\\w-]+)*@[\\w-]+(?:\\.[\\w-]+)+$">' +
      '<div class="invalid-text">{@@invalid_email}</div>' +
      "</div>" +
      "</div>" +
      '<div class="win-foot">' +
      '<button class="cancel">{@@cancel}</button>' +
      '<button class="submit" type="primary">{@@submit}</button>' +
      "</div>" +
      "</div>",

    ref: {
      inputs: "input, textarea",
      ratingEl: ".rating",
      submitEl: ".submit",
      cancelEl: ".cancel",
    },

    autoDestroy: true,

    rating: 5,

    init: function () {
      this.callSuper("win");

      this.ratingEl.com().setValue(this.rating);

      this.inputs.$on("input", function (e) {
        if (e.target.value) {
          $(e.target).addClass("touched");
        } else {
          $(e.target).removeClass("touched");
        }
      });

      this.inputs.$on("focus", function (e) {
        $(e.target).parent().addClass("active");
      });

      this.inputs.$on("blur", function (e) {
        var input = $(e.target);
        if (!input.val()) {
          input.parent().removeClass("active");
        }
      });

      this.submitEl.$on("click", this.onSubmit, this);
      this.cancelEl.$on("click", this.onClickCancel, this);
    },

    onSubmit: function (e) {
      
      e.preventDefault();

      if (!this.el.checkValidity()) {
        return;
      }

      var score = this.ratingEl.com().rating;

      var post = {
        related_id: apower.productId,
        type: apower.productType,
        action: "review",
        score: score,
        language: apower.lang,
        nocache: "1",
      };
      console.log(post)
      $.extend(post, this.el.formObj());

      this.showLoading();

      $.ajax({
        url: $.nocache("https://support.apowersoft.com/Api/review"),
        data: post,
        dataType: "jsonp",
        success: function (body) {
          this.hideLoading();

          if (body.status === "exist") {
            $.msg.alert(tr("already_reviewed"));
            this.hide();
          } else if (body.status === "failed") {
            $.msg.alert(tr("failed_to_review"));
          } else {
            this.onReviewSuccess(body, score);
          }
        }.bind(this),
      });
    },

    onClickCancel: function (e) {
      e.preventDefault();
      this.hide();
    },

    onReviewSuccess: function (body, score) {
      this.hide();
      apower.reviewChecker.setAsReviewed();

      var item = {
        id: body.id,
        score: score,
        add_time: $.formatDate(new Date()),
      };

      $.extend(item, this.el.formObj());

      if (item.title || item.review) {
        $(".review-win").com().onNewReview(item);
      }
    },
  });

  $.registerDir("open-review-form", {
    selector: "[data-open-review-form]",

    init: function () {
      this.el.$on("click", this.onClickEl, this);
    },

    onClickEl: function () {
      $.newCom("review-form").show();

      var reviewWin = $(".review").com();
      reviewWin ? reviewWin.hide() : null;
    },
  });

  $.registerDir("set-review-rating", {
    selector: ".rating",

    init: function () {
      if (this.el.find(".rating-count").length) {
        this.el.com().on("select", this.onSelect, this);
      }
    },

    onSelect: function (star) {
      $.newCom("review-form", { rating: star }).show();

      var reviewWin = $(".review").com();
      reviewWin ? reviewWin.hide() : null;
    },
  });

  //to check if reviewed
  apower.reviewChecker = $.registerOnce({
    reviewResult: undefined,

    init: function () {
      // if (apower.productId && apower.productType == '1') {	//for apowersoft products, other products has productType=2
      // 	this.isReviewed(function (isReviewed) {
      // 		if (isReviewed) {
      // 			this.addReviewThanks()
      // 		}
      // 	}, this)
      // }

      if (apower.productId && apower.productType == "1") {
        this.reviewResult = $.store.get("apower_reviewed_" + apower.productId);

        if (this.reviewResult) {
          this.addReviewThanks();
        }
      }
    },

    setAsReviewed: function () {
      this.reviewResult = true;
      $.store.set("apower_reviewed_" + apower.productId, true);
      this.addReviewThanks();
    },

    isReviewed: function (callback, scope) {
      if (this.reviewResult !== undefined) {
        callback.call(scope, this.reviewResult);
      } else {
        var post = {
          related_id: apower.productId,
          type: apower.productType,
          action: "is_review",
        };

        $.ajax({
          url: $.nocache("https://support.apowersoft.com/Api/review"),
          data: post,
          dataType: "jsonp",
          success: function (body) {
            callback.call(scope, (this.reviewResult = body.status == 1));
          }.bind(this),
        });
      }
    },

    addReviewThanks: function () {
      var ratingEls = $(".rating:has(.rating-count)").not(
        ".review-win .rating"
      );
      ratingEls.append(
        '<span class="rating-thanks" style="display: inline">' +
          tr("thanks_rating") +
          "</span>"
      );
    },
  });

  //review win
  $.register("review", "win", {
    template: function () {
      //Sophia修改，评分列表弹窗上方星评分要和页面上的星评分保持一致
      var rating = "5";
      if ($('[itemprop="ratingValue"]').length > 0) {
        rating = $('[itemprop="ratingValue"]').eq(0).text();
      } else {
        rating = $(".rating").eq(0).attr("data-rating");
      }
      var reviewCount =
        $('[itemprop="reviewCount"]').eq(0).text() ||
        $(".rating-count").text().select(/\d+/, 0) ||
        0;

      var template =
        '<div class="win review-win">' +
        '<div class="win-head">' +
        "<h2>{@@product_reviews}</h2>" +
        '<div class="review-add-group">' +
        '<div class="rating rating-sml" data-rating="' +
        rating +
        '">' +
        '<div class="rating-stars"></div>' +
        '<div class="rating-count"><span>' +
        reviewCount +
        "</span> {@@reviews}</div>" +
        "</div>" +
        '<div class="review-add" data-open-review>{@@add_your_review}</div>' +
        "</div>" +
        "</div>" +
        '<div class="win-body">' +
        "<ul></ul>" +
        "</div>" +
        "</div>";

      return template;
    },

    ref: {
      ratingEl: ".rating",
      addEl: ".review-add",
      listEl: ".win-body > ul",
      ratingCountEl: ".rating-count span",
    },

    page: -1,

    pageCount: 1,

    paging: 10,

    data: {},

    init: function () {
      this.callSuper("win");

      this.loadEl = $('<div class="loading-more"><div></div></div>').appendTo(
        this.body
      );
      this.addEl.$on("click", this.onClickAdd, this);
      this.body.$on("click", this.onClickLike, this);
      this.body.$on("scroll", this.onBodyScroll, this);

      this.on(
        "show",
        function () {
          if (this.page === -1) {
            this.loadPageData();
          }
        },
        this
      );
    },

    onClickAdd: function () {
      this.hide();
      $.newCom("review-form").show();
    },

    onClickLike: function (e) {
      var likeEl = $(e.target).closest(".review-like, .review-dislike");
      var isLike = likeEl.is(".review-like");
      var twoBtns = likeEl.parent().children(".review-like, .review-dislike");

      if (likeEl.length) {
        twoBtns.addClass("review-liked");
        var id = likeEl.closest("[data-id]").data("id");

        var post = {
          review_id: id,
          type: apower.productType,
          action: isLike ? "approval" : "oppose",
        };

        $.ajax({
          url: $.nocache("https://support.apowersoft.com/Api/review"),
          data: post,
          dataType: "jsonp",
          success: function (body) {
            if (body.status === "exist") {
            } else if (body.status === "failed") {
              twoBtns.removeClass("review-liked");
            } else {
              likeEl.text((Number(likeEl.text()) || 0) + 1);
            }
          },
        });
      }
    },

    onBodyScroll: function () {
      var body = this.body;

      if (
        this.page < this.pageCount &&
        !this.loadEl.hasClass("active") &&
        body[0].scrollTop >= body[0].scrollHeight - body[0].clientHeight
      ) {
        this.loadPageData();
      }
    },

    loadPageData: function () {
      this.page++;

      var post = {
        related_id: apower.productId,
        type: apower.productType,
        action: "get_review",
        start: this.page * this.paging,
        page_num: this.paging,
        language: apower.lang,
        nocache: "1",
      };

      this.loadEl.addClass("active");

      $.ajax({
        url: "https://support.apowersoft.com/Api/review",
        data: post,
        dataType: "jsonp",
        jsonpCallback: "jQueryCallback",
        cache: true,
        success: function (body) {
          this.loadEl.removeClass("active");
          this.pageCount = Math.ceil(body.total_count / this.paging);
          this.data[this.page] = body.all_review;
          this.onLoadData(this.data[this.page]);

          if (body.total_count > 0) {
            this.ratingCountEl.text(body.total_count);
          }
        }.bind(this),
      });
    },

    onLoadData: function (list, isPrepend) {
      if (!list || !list.length) {
        return;
      }

      var template =
        '<li class="review-item" data-id="{id}">' +
        '<div class="rating rating-sml" data-rating="{score}">' +
        '<div class="rating-stars"></div>' +
        '<div class="rating-time">{add_time}</div>' +
        "</div>" +
        '<div class="review-content">' +
        '<div class="review-text">' +
        "<header>{title}</header>" +
        "<i>by {name}</i>" +
        "<p>{review}</p>" +
        "</div>" +
        '<div class="review-like-group">' +
        '<div class="review-like">{approval_num}</div>' +
        '<div class="review-dislike">{oppose_num}</div>' +
        "</div>" +
        "</div>" +
        "</li>";

      for (var i = 0; i < list.length; i++) {
        var json = list[i];
        if (json.name === "Anonymous" || !json.name) {
          json.name = tr("anonymous") || json.name;
        }

        var html = template.format(json);
        var item = $(html).applyCom();

        if (isPrepend) {
          this.listEl.prepend(item);
        } else {
          this.listEl.append(item);
        }
      }
    },

    onNewReview: function (json) {
      this.show();

      json.approval_num = 0;
      json.oppose_num = 0;
      this.onLoadData([json], true);

      var item = this.listEl.children("li:first-child");
      item.find(".review-like-group").remove();
      item
        .find(".review-text")
        .append(
          '<div class="review-await">' + tr("success_to_review") + "</div>"
        );
      item.css({
        background: "#99d6eb",
      });
      item.width();
      item[0].style.transition = "background-color 1s linear";

      this.body[0].scrollTop = 0;

      setTimeout(function () {
        item.css({
          background: "#fff",
        });
      }, 500);
    },
  });

  $.registerDir("open-review", {
    selector: "[data-open-review], .rating-count",

    init: function () {
      this.el.$on("click", this.onClickEl, this);
    },

    onClickEl: function () {
      var reviewWin = $(".review-win").com() || $.newCom("review");
      reviewWin.show();
    },
  });
}
